import axios from 'axios';

// 环境的切换
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = './';
} else if (process.env.NODE_ENV === 'debug') {
    axios.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = './';
}

axios.defaults.timeout = 100000;

axios.defaults.headers.post['Content-type'] = 'application/json'

axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.error(error);
    })

axios.defaults.crossDomain = true
//Access-Control-Allow-Origin 指向前端 ip:port
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

function getAuthHeader() {
    return {
        'Authorization': `Bearer ${localStorage.getItem('jwt-token')}`
    };
}


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            headers: getAuthHeader(),
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            console.error(err)
            reject(err)
        })
    });
}

export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, {
            headers: getAuthHeader()
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
    });
}

export function put(url, data) {
    return new Promise((resolve, reject) => {
        axios.put(url, data, {
            headers: getAuthHeader()
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
    });
}

export function del(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {
            params: params,
            headers: getAuthHeader()
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                reject(err);
            });
    });
}


export function getzip(url){
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            responseType: 'arraybuffer'
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err)
        })
    });
}



// WEBPACK FOOTER //
// ./src/api/http.js